require('./RASuitabilityTestValid.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @components
const RASuitabilityTestAnswersInfo = require('../RASuitabilityTestAnswersInfo/RASuitabilityTestAnswersInfo');
const RASuitabilityTestResult = require('../RASuitabilityTestResult/RASuitabilityTestResult');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');

const {
    BrokerInvestmentSpecialist,
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');

const RASuitabilityTestReTestBox = require('../contactCenter/RASuitabilityTestReTestBox/RASuitabilityTestReTestBox');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @constants
const {
    RA_SUITABILITY_TEST_URL,
    PROC_RA_SUITABILITY_TEST_STATUS,
    PROC_RA_SUITABILITY_TEST_MODIFY_STATUS,
} = require('../../raConstants/index');
const { MODIFY_SUITABILITY_TEST } = require('constants/flagBasedFeatures');

class RASuitabilityTestValid extends React.Component {
    constructor(props) {
        super(props);

        this.handleFeatureModal = this.handleFeatureModal.bind(this);
    }

    handleFeatureModal() {
        const {
            history,
            immFlagBasedFeatures,
            onRetryTestClick,
            featureModalToggle,
        } = this.props;
        recordLink(
            PROC_RA_SUITABILITY_TEST_STATUS,
            PROC_RA_SUITABILITY_TEST_MODIFY_STATUS,
            null,
        );
        if (!immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST)) {
            featureModalToggle();
        } else {
            onRetryTestClick();
            history.push(RA_SUITABILITY_TEST_URL);
        }
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
            />
        );
    }

    buildLastTestResult() {
        const {
            date,
            clientRiskProfile,
            clientRiskProfileDescription,
            productDescription,
            immFlagBasedFeatures,
            clientSustainabilityProfileDescription,
        } = this.props;

        return (
            <RASuitabilityTestResult
                clientRiskProfile={clientRiskProfile}
                clientRiskProfileDescription={clientRiskProfileDescription}
                date={date}
                productDescription={productDescription}
                immFlagBasedFeatures={immFlagBasedFeatures}
                clientSustainabilityProfileDescription={
                    clientSustainabilityProfileDescription
                }
            />
        );
    }

    buildInfoTestBlock(retryMainText, retrySecondaryText) {
        const { immCheckStatus } = this.props;

        const link = immCheckStatus.get('canRepeatTest') ? (
            <OKLink modifier="complementary" onClick={this.handleFeatureModal}>
                <FormattedText value="raSuitabilityTestValid-raSuitabilityTestValid_callmeBackLink" />
            </OKLink>
        ) : null;

        return (
            <div className="ra-suitability-test-valid__info-test-block">
                <p>{retryMainText}</p>
                <p>{retrySecondaryText}</p>
                {link}
            </div>
        );
    }

    buildRetakeTestInfoBox() {
        const { retryMainText, retrySecondaryText, retryTitle } = this.props;
        const infoTestBlock = this.buildInfoTestBlock(
            retryMainText,
            retrySecondaryText,
        );

        return (
            <div className="ra-suitability-test-valid__content-box--margin">
                <BrokerInvestmentSpecialist
                    title={retryTitle}
                    infoTestBlock={infoTestBlock}
                />
            </div>
        );
    }

    buildReTestBoxCC() {
        const { immCheckStatus } = this.props;

        return (
            <RASuitabilityTestReTestBox
                canRepeatTest={immCheckStatus.get('canRepeatTest')}
            />
        );
    }

    buildTestAnswersInfo() {
        const { email } = this.props;

        return (
            <ContentBox customClassName="ra-suitability-test-valid__content-box ra-suitability-test-valid__content-box--margin">
                <RASuitabilityTestAnswersInfo email={email} />
            </ContentBox>
        );
    }

    render() {
        const { immFlagBasedFeatures } = this.props;
        const contentBoxTitle = formatText('raSuitabilityTestValid-title');
        const contentBoxMessage = formatText(
            'raSuitabilityTestValid-firstParagraph',
        );
        const lastTestResult = this.buildLastTestResult();
        const testAnswersInfo = this.buildTestAnswersInfo();
        const footerText = immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST)
            ? formatText(
                  'raSuitabilityTestValid-raSuitabilityTestValid_footerTextSuitability',
              )
            : formatText('raSuitabilityTestValid-footerText');
        // const footerButtonText = <FormattedText value="raSuitabilityTestValid-footerButtonText" />;
        const featureModal = this.buildFeatureModal();

        const topRightWidget = __CONTACT_CENTER__
            ? this.buildReTestBoxCC()
            : this.buildRetakeTestInfoBox();

        return (
            <section className="ra-suitability-test-valid">
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-md-8">
                                {featureModal}
                                <ContentBox
                                    title={contentBoxTitle}
                                    customClassName="ra-suitability-test-valid__content-box"
                                >
                                    <p className="ra-suitability-test-valid__box-content">
                                        {contentBoxMessage}
                                    </p>
                                    <div className="ra-suitability-test-valid__result">
                                        {lastTestResult}
                                    </div>
                                    <p className="ra-suitability-test-valid__footer-text">
                                        {footerText}
                                    </p>
                                    {/* <OKLink modifier="complementary" to={SUITABILITY_TEST_URL_READ_ONLY}>
                                        {footerButtonText}
                                    </OKLink> */}
                                </ContentBox>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                {topRightWidget}

                                {testAnswersInfo}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

RASuitabilityTestValid.propTypes = {
    clientRiskProfile: PropTypes.string.isRequired,
    clientRiskProfileDescription: PropTypes.string.isRequired,
    date: PropTypes.object.isRequired,
    email: PropTypes.string.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    onCheckMyAnswersClick: PropTypes.func.isRequired,
    onRetryTestClick: PropTypes.func.isRequired,
    productDescription: PropTypes.string.isRequired,
    retryMainText: PropTypes.string.isRequired,
    retrySecondaryText: PropTypes.string.isRequired,
    retryTitle: PropTypes.string.isRequired,
    clientSustainabilityProfileDescription: PropTypes.string,
};

module.exports = withRouter(RASuitabilityTestValid);
